(function () {
    'use strict';

    angular.module("imApp").factory("acSuppTransesAgeService", ['$ihttp', function ($ihttp) {
        let service = {
            getAcSuppTransesAge: function (parms) {
                return $ihttp.post({
                    method: 2798,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
